export default "__VITE_ASSET__549936d0__"